import styled from 'styled-components'
import ProcessItemCard from './ProcessItemCard'

const ListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 0 0.5rem;
`

const EmptyState = styled.div`
    text-align: center;
    padding: 2rem;
    color: ${({ theme }) => theme.font.label};
    font-size: 0.9rem;
`

const GroupHeader = styled.div`
    padding: 0.25rem 0.25rem 0;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.font.label};
`

const ProcessItemList = ({ lines, allLines, linesField, section, mode, onAction, onOpenDetail, completed, testIdBase }) => {
    if (!lines || lines.length === 0) {
        return <EmptyState>—</EmptyState>
    }

    // Headers appear only when the items carry more than one distinct tag —
    // a process whose items all belong to the same group renders as a flat list.
    const grouped = new Set(lines.map(l => l._tag).filter(Boolean)).size > 1
    let lastWh = null

    return (
        <ListWrapper>
            {lines.map((line, i) => {
                const showHeader = grouped && line._tag && line._tag !== lastWh
                if (showHeader) lastWh = line._tag
                return (
                    <div key={line.id} style={{ display: 'contents' }}>
                        {showHeader && <GroupHeader>{line._tag}</GroupHeader>}
                        <ProcessItemCard
                            line={line}
                            section={section}
                            mode={mode}
                            onAction={onAction}
                            onOpenDetail={onOpenDetail}
                            allLines={allLines}
                            linesField={linesField}
                            completed={completed}
                            testId={testIdBase && `${testIdBase}.${i + 1}`}
                        />
                    </div>
                )
            })}
        </ListWrapper>
    )
}

export default ProcessItemList
